// https://www.vuemastery.com/blog/vue-router-a-tutorial-for-vue-3/

import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home.vue";

import Balado from "@/views/Balado.vue";
import BaladoSingle from "@/views/BaladoSingle.vue";
import BaladoTestimonial from "@/views/BaladoTestimonial.vue";


import Page from "@/views/Page.vue";

import NotFound from "@/views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Balado,
    meta: {
      title: "Balado - Au-delà des Mots - L'Appui",
      description: "Ce balado est l’occasion de tendre le micro aux personnes proches aidantes afin qu’elles nous racontent leur vécu. D’ici là, aidez-nous à en enrichir le contenu en témoignant de votre expérience de proche aidance.",
      ogImage: ""
     },
  },
  {
    path: "/balado",
    name: "Balado",
    component: Balado,
    meta: {
      title: "Balado - Au-delà des Mots - L'Appui",
      description: "Ce balado est l’occasion de tendre le micro aux personnes proches aidantes afin qu’elles nous racontent leur vécu. D’ici là, aidez-nous à en enrichir le contenu en témoignant de votre expérience de proche aidance.",
      ogImage: ""
     },
     children: [
           {
             path: ':slug',
             name: "BaladoSingle",
             component: BaladoSingle,
             // props: { playing: true },
             meta: {
               title: "Bande-annonce - Des histoires qui résonnent: le Balado des proches aidants",
               description: "Ici Marina Orsini. J’ai le plaisir d’animer ce printemps l’émission “Des histoires qui résonnent : le Balado des proches aidants.”Saviez-vous qu’une personne sur quatre est proche aidante au Québec? Il s’agit peut-être de votre voisin, de votre mère, voire de vous.",
               ogImage: "/images/vignette2.png"
             }
           },
         ]
  },

  {
    path: "/balado/temoignage",
    name: "BaladoTestimonial",
    component: BaladoTestimonial,
    meta: {
      title: "",
      description: ""
    }
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


export default router;
